import { createSlice } from '@reduxjs/toolkit';
import {
  BloggerUploadImage,
  DeleteBlogger,
  EditBlogger,
  GetAllBlogCount,
  GetAllBlogger,
  GetAllBloggerAdvanced,
  GetBlogger,
  GetBloggerAdvanced,
  GetMyBlogger,
  GetMyBloggerAdvanced,
  GetSingleBlogger,
  PostBlogger,
  PostComment,
  SearchForBlogsByTitle,
} from './bloggersServicesSync';

const initialState = {
  isError: false,
  isSuccess: false,
  isPicLoading: false,
  isBlogLoading: false,
  articleImageLoader: false,
  all_blog_count_loader: false,
  all_blog_count: 0,
  message: '',
  allMessage: '',
  contentDetails: {},
  articleDetails: [],
  myArticleDetails: [],
  allArticleDetails: [],
  mylimit: 10,
  myPagination: 0,
  ordersLimit: 10,
  orderPagination: 0,
  myBloggersCount: 0,
  ordersBloggersCount: 0,
  allPage: 0,
  allLimit: 10,
  allPagination: 0,
  allBloggersCount: 0,
  averageLimit: 10,
  storiesPageLoad: false,
  storyTab: 'all',
  singleStoryPageLoader: false,
  singleStoryPageDetails: {},
  singleBlogDetails: {},
  allBlogComment: {},
  articleDetailsSearch: {},
  commentLoader: false,
  commentMessage: '',
  loaderIndicator: '',
};

export const bloggerSlice = createSlice({
  name: 'blogger',
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isPicLoading = false;
      state.isSuccess = false;
      state.isBlogLoading = false;
      state.message = '';
      state.articleImageLoader = false;
      state.all_blog_count_loader = false;
      state.all_blog_count = 0;
      state.mylimit = 10;
      state.message = 0;
      state.ordersLimit = 10;
      state.orderPagination = 0;
      state.myBloggersCount = 0;
      state.ordersBloggersCount = 0;
      state.storiesPageLoad = false;
      state.storyTab = 'all';
      state.articleDetails = [];
      state.myArticleDetails = [];
      state.singleStoryPageLoader = false;
      state.singleStoryPageDetails = {};
      state.articleDetailsSearch = {};
      state.allPagination = 0;
      state.allBloggersCount = 0;
      state.allMessage = '';
      state.allArticleDetails = [];
      state.allLimit = 10;
      state.allPage = 0;
      state.loaderIndicator = '';
    },

    checkMessage: (state, action) => {
      state.message = action.payload;
    },

    updateLoaderIndicator: (state, action) => {
      state.loaderIndicator = action.payload;
    },

    updataeSingleStoryPageLoader: (state, action) => {
      state.singleStoryPageLoader = action.payload;
    },

    checkImageDetails: (state, action) => {
      state.imageDetails = action.payload;
    },

    checkLoader: (state, action) => {
      state.articleImageLoader = action.payload;
    },

    updateCoverPics: (state, action) => {
      state.contentDetails = action.payload;
    },

    updateMyLimit: (state, action) => {
      state.mylimit = action.payload;
    },

    updateAllLimit: (state, action) => {
      state.allLimit = action.payload;
    },

    updateAllPage: (state, action) => {
      state.allPage = action.payload;
    },

    updateMyPagination: (state, action) => {
      state.myPagination = action.payload;
    },

    updateAllPagination: (state, action) => {
      state.allPagination = action.payload;
    },

    updateOrderLimit: (state, action) => {
      state.ordersLimit = action.payload;
    },

    updateOrderPagination: (state, action) => {
      state.orderPagination = action.payload;
    },

    updateMyBloggerCount: (state, action) => {
      state.myBloggersCount = action.payload;
    },

    updateOrderBloggerCount: (state, action) => {
      state.ordersBloggersCount = action.payload;
    },

    updateStoriesPageLoader: (state, action) => {
      state.storiesPageLoad = action.payload;
    },

    updateStoreTab: (state, action) => {
      state.storyTab = action.payload;
    },

    updateSingleBlogDetails: (state, action) => {
      state.singleBlogDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(BloggerUploadImage.pending, (state, action) => {
        state.isPicLoading = true;
      })
      .addCase(BloggerUploadImage.fulfilled, (state, action) => {
        state.isPicLoading = false;
        state.message = action.payload?.message;
        state.contentDetails = action.payload?.data;
      })
      .addCase(BloggerUploadImage.rejected, (state, action) => {
        state.isPicLoading = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(PostBlogger.pending, (state, action) => {
        state.isBlogLoading = true;
      })
      .addCase(PostBlogger.fulfilled, (state, action) => {
        state.isBlogLoading = false;
        state.message = action.payload?.message;
      })
      .addCase(PostBlogger.rejected, (state, action) => {
        state.isBlogLoading = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(EditBlogger.pending, (state, action) => {
        state.isBlogLoading = true;
      })
      .addCase(EditBlogger.fulfilled, (state, action) => {
        state.isBlogLoading = false;
        state.message = action.payload?.message;
      })
      .addCase(EditBlogger.rejected, (state, action) => {
        state.isBlogLoading = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(DeleteBlogger.pending, (state, action) => {
        state.isBlogLoading = true;
      })
      .addCase(DeleteBlogger.fulfilled, (state, action) => {
        const details = state.articleDetails?.docs;

        const findIndex = details?.findIndex(
          (item) => item?._id === action?.payload?.data?._id
        );

        details?.splice(findIndex, 1, action?.payload?.data);

        state.articleDetails = { ...state?.articleDetails, docs: details };
        state.isBlogLoading = false;
        state.loaderIndicator = '';
        state.message = action.payload?.message;
      })
      .addCase(DeleteBlogger.rejected, (state, action) => {
        state.isBlogLoading = false;
        state.message = action.payload?.message;
        state.loaderIndicator = '';
      });

    builder
      .addCase(GetBlogger.pending, (state, action) => {
        state.storiesPageLoad = true;
      })
      .addCase(GetBlogger.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
        state.articleDetails = action?.payload?.data;
        state.allPage = action?.payload?.data?.page;
        state.ordersBloggersCount = action?.payload?.count;
      })
      .addCase(GetBlogger.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(GetBloggerAdvanced.pending, (state, action) => {
        state.storiesPageLoad = false;
      })
      .addCase(GetBloggerAdvanced.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
        state.orderPagination = state.orderPagination + 1;
        state.ordersLimit = state.ordersLimit + state.averageLimit;
        state.articleDetails = [...action?.payload?.data];
        state.ordersBloggersCount = action?.payload?.count;
      })
      .addCase(GetBloggerAdvanced.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(GetMyBlogger.pending, (state, action) => {
        state.storiesPageLoad = true;
      })
      .addCase(GetMyBlogger.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
        state.myArticleDetails = action?.payload?.data;
        state.myBloggersCount = action?.payload?.count;
      })
      .addCase(GetMyBlogger.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(GetMyBloggerAdvanced.pending, (state, action) => {
        state.storiesPageLoad = false;
      })
      .addCase(GetMyBloggerAdvanced.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
        state.myPagination = state.myPagination + 1;
        state.mylimit = state.mylimit + state.averageLimit;
        state.myArticleDetails = [...action?.payload?.data];
        state.myBloggersCount = action?.payload?.count;
      })
      .addCase(GetMyBloggerAdvanced.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(GetSingleBlogger.pending, (state, action) => {
        state.singleStoryPageLoader = true;
      })
      .addCase(GetSingleBlogger.fulfilled, (state, action) => {
        state.singleStoryPageLoader = false;
        state.message = action.payload.message;
        state.singleStoryPageDetails = action.payload?.data;
        // state.allBlogComment = action.payload[1]?.data;
      })
      .addCase(GetSingleBlogger.rejected, (state, action) => {
        state.singleStoryPageLoader = false;
        state.message = action.payload[0]?.message;
      });

    builder
      .addCase(GetAllBlogger.pending, (state, action) => {
        state.storiesPageLoad = true;
      })
      .addCase(GetAllBlogger.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.allMessage = action.payload?.message;
        state.allArticleDetails = action?.payload?.data;
        state.allBloggersCount = action?.payload?.count;
      })
      .addCase(GetAllBlogger.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.allMessage = action.payload?.message;
      });

    builder
      .addCase(GetAllBloggerAdvanced.pending, (state, action) => {
        state.storiesPageLoad = false;
      })
      .addCase(GetAllBloggerAdvanced.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.allMessage = action.payload?.message;
        state.allPagination = state.allPagination + 1;
        state.allLimit = state.allLimit + state.averageLimit;
        state.allArticleDetails = [...action?.payload?.data];
        state.allBloggersCount = action?.payload?.count;
      })
      .addCase(GetAllBloggerAdvanced.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.allMessage = action.payload?.message;
      });

    builder
      .addCase(PostComment.pending, (state, action) => {
        state.commentLoader = true;
      })
      .addCase(PostComment.fulfilled, (state, action) => {
        const payload = {
          ...state.allBlogComment,
          data: [...state.allBlogComment?.data, action.payload?.data],
          count: state.allBlogComment?.count + 1,
        };

        state.commentLoader = false;
        state.commentMessage = action.payload?.message;
        state.allBlogComment = payload;
      })
      .addCase(PostComment.rejected, (state, action) => {
        state.commentLoader = false;
        state.commentMessage = action.payload?.message;
      });

    builder
      .addCase(GetAllBlogCount.pending, (state, action) => {
        state.all_blog_count_loader = true;
      })
      .addCase(GetAllBlogCount.fulfilled, (state, action) => {
        state.all_blog_count_loader = false;
        state.message = action.payload?.message;
        state.all_blog_count = action?.payload?.data;
      })
      .addCase(GetAllBlogCount.rejected, (state, action) => {
        state.all_blog_count_loader = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(SearchForBlogsByTitle.pending, (state, action) => {
        state.storiesPageLoad = true;
      })
      .addCase(SearchForBlogsByTitle.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
        state.articleDetailsSearch = action?.payload?.data;
      })
      .addCase(SearchForBlogsByTitle.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
      });
  },
});

export const {
  reset,
  checkMessage,
  checkImageDetails,
  checkLoader,
  updateOrderLimit,
  updateMyLimit,
  updateMyBloggerCount,
  updateOrderBloggerCount,
  updateStoriesPageLoader,
  updateCoverPics,
  updateMyPagination,
  updateOrderPagination,
  updateStoreTab,
  updataeSingleStoryPageLoader,
  updateAllLimit,
  updateAllPagination,
  updateSingleBlogDetails,
  updateAllPage,
  updateLoaderIndicator,
} = bloggerSlice.actions;

export default bloggerSlice.reducer;
